
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MerchantConfigurationStatus } from '@/enums/SmoothrPay';

/** Colour reads the same as the new backoffice's status tag. */
@Component
export default class MerchantStatusChip extends Vue {
  @Prop({ type: String, required: true }) public status!: MerchantConfigurationStatus;

  get color(): string {
    switch (this.status) {
      case MerchantConfigurationStatus.ACTIVE:
        return 'success';
      case MerchantConfigurationStatus.ONBOARDING:
      case MerchantConfigurationStatus.INVITED:
        return 'info';
      case MerchantConfigurationStatus.SUSPENDED:
        return 'warning';
      case MerchantConfigurationStatus.CLOSED:
        return 'error';
      default:
        return 'grey';
    }
  }
}
